import { Alert, AlertTitle, Typography } from '@mui/material';

const EventDemographicFormInstructions = ({ event }) => {
  let bodyText;
  let bulletTexts = [];
  switch (event.curriculum.audience) {
    case 'Youth':
      bodyText = <Typography variant="body1" component="div" id="alert-dialog-description">
        Enter the number of youth participants in each of the demographic categories below.
        This can be collected from a child&#39;s caregiver or the partner agency.
      </Typography>;
      bulletTexts.push(<Typography variant="body1" component="div">
        Use &quot;Prefer not to answer&quot; when <span
        style={{textDecoration: 'underline'}}>you tried</span> to
        get the demographics, but the caregiver or partner agency could not provide them.
      </Typography>);
      bulletTexts.push(<Typography variant="body1" component="div">
        Only use &quot;unknown&quot; when you <span style={{textDecoration: 'underline'}}>did not</span> try
        to collect the demographics.
      </Typography>);
      break;
    case 'Family':
      bodyText = <Typography variant="body1" component="div" id="alert-dialog-description">
        Enter the number of participants in each of the demographic categories below. These should be collected
        directly from the participant. Parents or caregivers can complete the demographics for their child.
      </Typography>;
      bulletTexts.push(<Typography variant="body1" component="div">
        Use &quot;Prefer not to answer&quot; when <span
        style={{textDecoration: 'underline'}}>you tried</span> to
        get the demographics, but the individual chose not to share them.
      </Typography>);
      bulletTexts.push(<Typography variant="body1" component="div">
        Only use &quot;Unknown&quot; when you <span style={{textDecoration: 'underline'}}>did not</span> try
        to collect the demographics.
      </Typography>);
      break;
    case 'Adults':
    default:
      bodyText = <Typography variant="body1" component="div" id="alert-dialog-description">
        Enter the number of participants in each of the demographic categories below. These should be
        collected directly from the participant.
      </Typography>;
      bulletTexts.push(<Typography variant="body1" component="div">
        Use &quot;Prefer not to answer&quot; when <span
        style={{textDecoration: 'underline'}}>you tried</span> to
        get the demographics, but the individual chose not to share them.
      </Typography>);
      bulletTexts.push(<Typography variant="body1" component="div">
        Only use &quot;Unknown&quot; when you <span style={{textDecoration: 'underline'}}>did not</span> try
        to collect the demographics.
      </Typography>);
      break;
  }

  return (
    <Alert severity="info" sx={{ marginBottom: '16px' }} id="demographics-instructions">
      <AlertTitle>Instructions</AlertTitle>
      <Typography variant="body1" component="div" id="alert-dialog-description">
        {bodyText}
      </Typography>
      <ul>
        {bulletTexts.map((text, i) => (
          <li key={`bullet-${i}`}>
            <Typography variant="body1" component="div">
              {text}
            </Typography>
          </li>
        ))}
      </ul>
    </Alert>
  );
};

export default EventDemographicFormInstructions;
